import { Injectable } from '@angular/core';
import { CardBackgroundViewModel } from '../../card-background-view-model';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CardStack } from '../../../../../../../models/menu/section/card-stacks/card-stack';

@Injectable()
export class FikaConcentrateAddressCardStackBackgroundViewModel extends CardBackgroundViewModel {
  private static BOTTOM_HEIGHT_IN_REM = 2.625;
  private static REM_TO_PX_CONVERSION_VALUE = 16;

  public readonly bottomHeight$ = combineLatest([this.cardStack$, this.preview$]).pipe(
    map(([cardStack, preview]) => {
      return this.getHeightAdjustment(
        cardStack,
        FikaConcentrateAddressCardStackBackgroundViewModel.BOTTOM_HEIGHT_IN_REM,
        preview
      );
    })
  );

  private getHeightAdjustment(cardStack: CardStack, bottomHeight: number, preview: boolean) {
    const bleed = (cardStack?.nonPerforatedBleedBorderInInches() ?? 0) * CardStack.PIXELS_PER_INCH;
    const additionalHeight = cardStack?.isOnRegularPaper() && !preview ? bleed : 0;
    return (
      bottomHeight * FikaConcentrateAddressCardStackBackgroundViewModel.REM_TO_PX_CONVERSION_VALUE + additionalHeight
    );
  }
}
